import { Flex, FormLabel } from "@chakra-ui/react";
import { QuestionVisibilitySwitch } from "../../QuestionVisibility";
import { PermissionLevelSwitch } from "../Edit/PermissionLevel";
import { QuestionConstraintsSwitch } from "../Edit/QuestionContraints";
import { QuestionLinkSwitch } from "../Edit/QuestionLink";
import { RequirementSwitch } from "../Edit/Requirement";
import { VerificationSwitch } from "../Edit/Verification";

type Props = {
  questionId: uuid;
  hide?: "QuestionVisibility"[];
};
export const ConfigureQuestion: React.FC<Props> = ({ questionId, hide }) => {
  return (
    <Flex direction="column" gap="3">
      <FormLabel as="div" margin="0">
        Configure question
      </FormLabel>
      <VerificationSwitch questionId={questionId} />
      <QuestionLinkSwitch questionId={questionId} />
      <PermissionLevelSwitch questionId={questionId} />
      <RequirementSwitch questionId={questionId} />
      <QuestionConstraintsSwitch questionId={questionId} />
      {!hide?.includes("QuestionVisibility") ? (
        <QuestionVisibilitySwitch questionId={questionId} />
      ) : null}
    </Flex>
  );
};
